module.exports = __webpack_public_path__ + "static/img/sy.911a5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sy.png
// module id = FMTq
// module chunks = 1